export const jobCodes = {
    0: {
        // MT
        id: 0,
        jobCode: 'US-KEY-09727 09/25',
    },
    // 1: {
    //     // HCC
    //     id: 1,
    //     jobCode: 'US-PDO-01572 01/22',
    // },
    2: {
        // MEL
        id: 2,
        jobCode: 'US-OOC-02819 03/25',
    },
    // 3: {
    //     // MEL - Adjuvant
    //     id: 3,
    //     jobCode: 'US-OOC-01141  05/21',
    // },
    4: {
        // ALL LUNG / NSCLC
        id: 4,
        jobCode: 'US-LAM-04767 05/25',
    },
    5: {

    },
    6: {

    },
    7: {

    },
    8: {
        // RCC (adjuvant)
        id: 8,
        jobCode: 'US-JRC-00857 09/24',
    },
    9: {
        // HNSCC
        id: 9,
        jobCode: 'US-OHN-02008 10/24',
    },
    10: {
        // 1L Mono HNSCC
        id: 10,
        jobCode: '',
    },
    11: {
        // 2L Mono HNSCC
        id: 11,
        jobCode: '',
    },
    // 12 is missing since the ids were duplicated from indications.js
    13: {
        // cSCC
        id: 13,
        jobCode: 'US-OHC-00366 02/25',
    },
    14: {
        // MCC
        id: 14,
        jobCode: 'US-PDO-02475 04/24',
    },
    15: {
        // UC
        id: 15,
        jobCode: 'US-OBD-01917 02/25',
    },
    16: {
        // id: 16,
        // jobCode: 'US-OBD-00748  05/21',
    },
    17: {
        // NMIBC
        id: 17,
        jobCode: 'US-NMI-00832 12/24',
    },
    18: {
        // GASTRIC
        id: 18,
        jobCode: 'US-OGA-00892 06/25',
    },
    19: {
        // ESO
        id: 19,
        jobCode: 'US-ESO-00233 06/25',
    },
    20: {
        // CHL
        id: 20,
        jobCode: 'US-PDO-02578 07/25',
    },
    21: {
        // PMBCL
        id: 21,
        jobCode: 'US-PDO-02579 07/25',
    },
    22: {
        // MSI-H
        id: 22,
        jobCode: 'US-OVA-00928 04/23',
    },
    23: {
        // CRC
        id: 23,
        jobCode: 'US-OVC-00983 04/25',
    },
    24: {
        // CERVICAL
        id: 24,
        jobCode: 'US-CER-00631 07/25',
    },
    25: {
        // TMB-H
        id: 25,
        jobCode: 'US-TMB-00085 05/23',
    },
    26: {
        // TNBC
        id: 26,
        jobCode: 'US-OBR-02499 05/25',
    },
    // not sure if these will continue to have their own job codes or if it will be a part of MT submission in the future
    27: {
        // ALL Biomarker pages
        id: 27,
        jobCode: 'US-KEY-09984 08/25',
    },
    28: {
        // MSI-H Biomarker
        // id: 28,
        // jobCode: 'US-KEY-06845 06/23',
    },
    29: {
        // TMB-H Biomarker
        // id: 29,
        // jobCode: 'US-TMB-00081 07/22',
    },
    30: {
        // MT DOSING
        id: 30,
        jobCode: 'US-KEY-10129 09/25',
    },
    31: {
        // RESOURCES (RESOURCE CENTER + MOA + KEY+YOU)
        id: 31,
        jobCode: 'US-KEY-09762 07/25',
    },
    32: {
        // ENDO
        id: 32,
        jobCode: 'US-END-00828 07/25',
    },
    33: {
        // RCC (advanced)
        id: 33,
        jobCode: 'US-RCC-01076 02/25',
    },
    34: {
        // Dose Modifications, Admin & Prep
        id: 34,
        jobCode: 'US-KEY-09886 07/25',
    },
    35: {
        // AA Dosing
        id: 35,
        jobCode: 'US-KEY-06174 01/23',
    },
    36: {
        // Biliary
        id: 36,
        jobCode: 'US-KEB-00109 10/25',
    },
    37: {
        // HNSCC squamous
        id: 37,
        jobCode: 'US-OHN-02115 06/25',
    },
   38: {
        // subq landing page
        id: 38,
        jobCode: 'US-PDS-00126 09/25',
    },
    39:{
        //indication ESIT
        id: 39,
        jobCode: 'US-KEY-09981 08/25',
    }
};
